export const numberInCircleCharacters = [
	"\u24EA",
	"\u2460",
	"\u2461",
	"\u2462",
	"\u2463",
	"\u2464",
	"\u2465",
	"\u2466",
	"\u2467",
	"\u2468",
	"\u2469",
	"\u246A",
	"\u246B",
	"\u246C",
	"\u246D",
	"\u246E",
	"\u246F",
	"\u2470",
	"\u2471",
	"\u2472",
	"\u2473",
] as const;
